import { useMemo } from 'react';
import { IPaginationModel } from '@/types/admin/dataTable';
import { ITaskFilterModel, ITaskSortModel, TASK_SORT_OPTIONS } from '@/types/admin/tasks';

export const useTasksDefaults = () => {
  const defaultFilterModel: ITaskFilterModel = useMemo(() => ({
    search: '',
    creator: [],
    assignedTo: undefined,
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  }), []);

  const defaultSortModel: ITaskSortModel[] = useMemo(() => ([
    { field: 'newestCreationDate', sort: 'desc' },
  ]), []);

  const defaultPaginationModel: IPaginationModel = useMemo(() => ({
    page: 0,
    pageSize: 50,
  }), []);

  return { defaultFilterModel, defaultSortModel, defaultPaginationModel, TASK_SORT_OPTIONS } as const;
}


